var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2.5,
    width: 12,
    height: 12,
    rx: 6,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2.5,
    width: 12,
    height: 12,
    rx: 6,
    stroke: "#0054D1",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedBlue);
export default __webpack_public_path__ + "static/media/checkedBlue.f2a8a5d169cf5ea463fed1474938dbb0.svg";
export { ForwardRef as ReactComponent };